// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"173893ad","496":"653eda12"}[chunkId] + ".chunk.js";
};